module.exports = __webpack_public_path__ + "files/2c554b007e26c48d995a1afce86f131b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/themes/windows_dark.png
 ** module id = 827
 ** module chunks = 0
 **/